import React from 'react';

/**
 * LogoIconDecoration is a premium background decoration component.
 * It uses the official decor-site.png icon as a subtle, elegant watermark.
 */
export default function LogoIconDecoration({ 
  className = "w-96 h-96 opacity-[0.03]", 
  style = {} 
}) {
  return (
    <div 
      className={`absolute pointer-events-none overflow-hidden select-none z-0 ${className}`}
      style={style}
    >
      <img 
        src="https://assets.auxodev.dk/assets/6b13c390-5e11-4ba2-a04f-8e3fde27ab67/decor-site.png" 
        alt="" 
        className="w-full h-full object-contain"
      />
    </div>
  );
}
